module.exports = __webpack_public_path__ + "static/media/main-weapon.16beae76.png";